export const ensureArray = (x: any[] | string | number): any[] => (Array.isArray(x) ? x : [x]);
